import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Drawer, IconButton, List, ListItem, ListItemText } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { Menu as MenuIcon } from '@mui/icons-material';
import styles from './Header.module.css';
import { useTranslation } from 'react-i18next'; // Import from react-i18next

const Header = () => {
    const location = useLocation();  // Get the current route/path
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { t, i18n } = useTranslation(); // Translation hook

    // Toggle Drawer open/close
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    // Language toggle handler
    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'th' : 'en'; // Switch between 'en' and 'th'
        i18n.changeLanguage(newLang);
    };

    // Function to check if the current route matches the `to` prop
    const isActiveRoute = (route) => location.pathname === route;

    return (
        <AppBar position="sticky" className={styles.appBar}>
            <Toolbar className={styles.toolbar}>
                <Typography variant="h6" component={Link} to="/" className={styles.link}>
                    <img src="/logo.svg" alt="Logo" className={styles.logo} />
                </Typography>

                {/* Hamburger Menu Icon (Only on mobile) */}
                <div style={{ flexGrow: 1 }} /> {/* Empty space to push the icon to the right */}
                <IconButton
                    edge="end"
                    className={styles.menuButton}
                    color="inherit"
                    aria-label="menu"
                    onClick={() => setDrawerOpen(true)}
                    sx={{
                        display: { xs: 'block', sm: 'none' },  // Show on mobile only
                        zIndex: 1201  // Ensure it's above other elements
                    }}
                >
                    <MenuIcon />
                </IconButton>


                {/* Desktop Navigation (Only on larger screens) */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',  // Centering the buttons
                        flexGrow: 1,
                        position: 'absolute',  // Change to absolute when hidden on mobile
                        left: 0,
                        right: 0,
                        zIndex: 999,
                        visibility: 'visible', // Keeps buttons visible
                    }}
                    className={`${styles.desktopNav} ${window.innerWidth < 600 ? styles.desktopNavHidden : ''}`} // Hide on small screens
                >
                    <Button
                        component={Link}
                        to="/"
                        className={`${styles.button} ${isActiveRoute('/') ? styles.activeButton : ''}`}
                        sx={{ display: { xs: 'none', sm: 'block' } }}  // Hide on mobile
                    >
                        {t("Header.home")}
                    </Button>
                    <Button
                        component={Link}
                        to="/gallery"
                        className={`${styles.button} ${isActiveRoute('/gallery') ? styles.activeButton : ''}`}
                        sx={{ display: { xs: 'none', sm: 'block' } }}  // Hide on mobile
                    >
                        {t("Header.gallery")}
                    </Button>
                    <Button
                        component={Link}
                        to="/about"
                        className={`${styles.button} ${isActiveRoute('/about') ? styles.activeButton : ''}`}
                        sx={{ display: { xs: 'none', sm: 'block' } }}  // Hide on mobile
                    >
                        {t("Header.about")}
                    </Button>
                    <Button
                        component={Link}
                        to="/application"
                        className={`${styles.button} ${isActiveRoute('/application') ? styles.activeButton : ''}`}
                        sx={{ display: { xs: 'none', sm: 'block' } }}  // Hide on mobile
                    >
                        {t("Header.application")}
                    </Button>
                    <Button
                        component={Link}
                        to="/contact"
                        className={`${styles.button} ${isActiveRoute('/contact') ? styles.activeButton : ''}`}
                        sx={{ display: { xs: 'none', sm: 'block' } }}  // Hide on mobile
                    >
                        {t("Header.contact_us")}
                    </Button>
                    <Button
                        aria-label="Toggle language"
                        color="inherit"
                        onClick={toggleLanguage}
                        sx={{ mx: 1 }}
                    >
                        {i18n.language === 'en' ? 'ไทย' : 'EN'}
                    </Button>
                </div>
            </Toolbar>

            {/* Mobile Drawer (for the hamburger menu) */}
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <List>
                    <ListItem
                        button
                        component={Link}
                        to="/"
                        onClick={toggleDrawer(false)}
                        className={isActiveRoute('/') ? styles.activeButton : ''}
                    >
                        <ListItemText primary={t("Header.home")} />
                    </ListItem>
                    <ListItem
                        button
                        component={Link}
                        to="/gallery"
                        onClick={toggleDrawer(false)}
                        className={isActiveRoute('/gallery') ? styles.activeButton : ''}
                    >
                        <ListItemText primary={t("Header.gallery")} />
                    </ListItem>
                    <ListItem
                        button
                        component={Link}
                        to="/about"
                        onClick={toggleDrawer(false)}
                        className={isActiveRoute('/about') ? styles.activeButton : ''}
                    >
                        <ListItemText primary={t("Header.about")} />
                    </ListItem>
                    <ListItem
                        button
                        component={Link}
                        to="/application"
                        onClick={toggleDrawer(false)}
                        className={isActiveRoute('/application') ? styles.activeButton : ''}
                    >
                        <ListItemText primary={t("Header.application")} />
                    </ListItem>
                    <ListItem
                        button
                        component={Link}
                        to="/contact"
                        onClick={toggleDrawer(false)}
                        className={isActiveRoute('/contact') ? styles.activeButton : ''}
                    >
                        <ListItemText primary={t("Header.contact_us")} />
                    </ListItem>
                </List>
            </Drawer>
        </AppBar>
    );
};

export default Header;
